import React from "react";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import styled from "styled-components";
const MyDiv = styled.div`
  padding: 24px 20px 16px 20px;
`;
export default function AiCommentServiceSettingGuide({ closeModal }) {
  return (
    <MyDiv className="flex flex-col gap-6">
      <b className="text-lg">댓글 자동 등록이란?</b>
      <p>
        리뷰 작성일을 기준으로 2~3일 뒤에 댓글을 달게 되면 주문했던 고객에게
        댓글 등록 푸시 알림이 발송되어 우리 매장을 한 번 더 노출할 수 있어요.
      </p>
      <p>
        사장님께서 직접 모든 댓글을 관리하시기 힘드시다면 자동 등록을 이용해
        편리한 댓글 관리를 경험해 보세요.
      </p>

      <SolidBlueBtn onClick={closeModal}>확인</SolidBlueBtn>
    </MyDiv>
  );
}
